import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/settings` — kept as a redirect to the household half.
 *
 * ==========================================================================================
 * WHY IT STILL EXISTS AT ALL
 * ==========================================================================================
 *
 * It was the one settings page and became two on 2026-08-14 — `settings_.household.tsx` carries the
 * argument. Deleting this route was the obvious next step and is the wrong one, because `/settings` is
 * not only a thing the application links to:
 *
 *   - `activity.tsx` resolves the activity feed's `settings` module to it, and 018's rule is that a
 *     destination is a PLACE rather than a record — so it needs somewhere to land, not a 404;
 *   - `onboarding.spec.ts` and `sign-in.spec.ts` use it as "some authenticated URL" when asserting that
 *     the guards redirect a member who has no household or no session;
 *   - `household-management.spec.ts` and `profile-picture.spec.ts` navigate to it and then interact with
 *     the member list, which is on the household half;
 *   - and it is the URL anyone who bookmarked settings already has.
 *
 * HOUSEHOLD RATHER THAN PROFILE, because every one of those callers wants the household half. The activity
 * feed's `settings` module covers household, membership and invite events; both specs that interact after
 * navigating here reach for the member list.
 *
 * `beforeLoad` rather than a component that navigates: the redirect happens before anything renders, so
 * there is no frame of an empty page and no entry in the history stack to go "back" into.
 */
export const Route = createFileRoute("/_authenticated/_shell/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/household", replace: true });
  },
});
